export const TRACKING_NAMESPACE = 'Customer Data Properties';
export const TRACKING_EVENT_NAME = 'Interaction';
export const TRACKING_SCREEN = 'property-value-citations';